export const FIELD_TYPES = {
  text: 10,
  date: 20,
  checkbox: 30,
};
